import { Button, Input, Modal} from "antd";
import React, { useEffect, useState } from "react";
import styles from "./DriversContainer.module.scss";
import  phoneIcon  from "../../Assets/my BIds/Frame.svg"
import Paginations from "Components/UI/Pagination/Pagination";
import { useAppDispatch } from "Redux/store";
import { useSelector } from "react-redux";
import { selectCurrentDriver, selectDriverList } from "Redux/Driver/slice";
import { createDriver, getDriver, getDriverList } from "Redux/Driver/reducer";
import { useParams } from "react-router";
import { Controller, useForm } from "react-hook-form";



export const DriversContainer = () => {
    const [isAddDriverOpen, setIsAddDriverOpen] = useState(false);
    const [isDriverInfoOpen, setIsDriverInfoOpen] = useState(false);
    const dispatch = useAppDispatch();
    const driverList = useSelector(selectDriverList);
    const params = useParams();
    const currentDriver = useSelector(selectCurrentDriver);
    const { control, handleSubmit} = useForm();

    

   

    useEffect(() => {
      dispatch(getDriverList());
    }, []);

    useEffect(() => {
      if(params.id) {
        const driverId = parseInt(params.id, 10);
        dispatch(getDriver(driverId));
      }
    }, [params.id]);

    const handleAddDriver = (values: any) => {
      dispatch(createDriver(values));
    }

    const hanldeAddDriverModal = () => setIsAddDriverOpen(true);
    const hanldeDriverInfo = () => {

      setIsDriverInfoOpen(true);
    } 
  return (
    <div className={styles.drivers}>
      <div className={styles.drivers__header}>
        <h1>Drivers</h1>

        <Button className={styles.drivers__header__btn} onClick={hanldeAddDriverModal}>
          + Add driver
        </Button>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            
            <th>DRIVER</th>
            <th>PHONE NUMBER</th>
            <th>ADDRESS</th>
            <th>RESPONSIBLE</th>

            <th>ACTION </th>
          </tr>
        </thead>

        <tbody>
          {driverList?.map((driver) => (
            <tr>
            
            <td><p className={styles.name} onClick={hanldeDriverInfo}>{driver.first_name} {driver.last_name}</p>
             
              </td>
              <td>
              {driver.phone_number}
              </td>
              <td>
              {driver.address}
              </td>
              <td>
                -
              </td>
              <td>
                <img src={phoneIcon} alt="phone-icon" />
              </td>
            </tr>
  
           
              
            
          ))}
        </tbody>
      </table>
      <Paginations link="drivers"/>


      {/* Add Driver Modal */}
      <Modal
        onCancel={() => setIsAddDriverOpen(false)}
        title={<h2 className={styles.addDriverTitle}>Add Driver</h2>}
        visible={isAddDriverOpen}
        width={800}
        footer={null}
      >
        <div className={styles.addVehicleModal}>
          <form className={styles.form} onSubmit={handleSubmit(handleAddDriver)}>
            <h3 >Driver info</h3>
            <div className={styles.mainInfo}>
              <div>
                <label htmlFor="">First Name</label>
                <Controller 
                control={control}
                name="first_name"
                render={({field}) => (
                  <Input 
                  type="text"
                  required
                  {...field}
                  />
                )}
                />
               
              </div>
              <div>
                <label htmlFor="">Last Name</label>
                <Controller 
                control={control}
                name="last_name"
                render={({field}) => (
                  <Input
                  type="text"
                  required
                  {...field}
                  />
                )}
                />
                
              </div>
              <div>
                <label htmlFor="">Date of Birth</label>
                <Controller 
                  control={control}
                  name="date_of_birth"
                  render={({field}) => (
                    <Input type="date"
                    {...field}
                    />
                  )}
                />
                
              </div>
              <div>
                <label htmlFor="">Email</label>
                <Controller 
                control={control}
                name="email"
                render={({field}) => (
                  <Input type="email"
                  required
                  {...field}
                  />
                )}
                />

                
              </div>
              <div>
                <label htmlFor="">SSN</label>
                <Controller
                name="ssn"
                control={control}
                render={({field}) => (
                  <Input 
                  type="number"
                  {...field}
                  />
                )}
                />
                
              </div>
              <div>
                <label htmlFor="">Address Line</label>
                <Controller 
                name="address"
                control={control}
                render={({field}) => (
                  <Input 
                  type="text"
                  required
                  {...field}
                  />
                )}
                />
                
              </div>
              <div>
                <label htmlFor="">City</label>
                <Controller 
                name="city"
                control={control}
                render={({field}) => (
                  <Input 
                  type="text"
                  {...field}
                  />
                )}
                />
                
              </div>
              <div>
                <label htmlFor="">State</label>
                <Controller 
                name="state"
                control={control}
                render={({field}) => (
                  <Input 
                  type="text"
                  {...field}
                  />
                )}
                />
                
              </div>
              <div>
                <label htmlFor="">ZIP</label>
                <Controller 
                name="zip_code"
                control={control}
                render={({field}) => (
                  <Input />
                )}
                />
                
              </div>
              <div>
                <label htmlFor="">Phone</label>
                <Controller 
                control={control}
                name="phone_number"
                render={({field}) => (
                  <Input type="phone"
                  {...field}
                  />
                  
                )}
                />
                
              </div>
              <div>
                <label htmlFor="">Emergency Phone</label>
                <Input type="phone"/>
              </div>
              <div>
                <label htmlFor="">Second Driver (team)</label>
                <Input className={styles.checkbox} type="checkbox"/>
              </div>
            </div>
            

           

            <h3>Driver  License</h3>
            <div className={styles.mainInfo}>
              <div>
                <label htmlFor="">License number</label>
                <Input />
              </div>
              <div>
                <label htmlFor="">License state</label>
                <Input />
              </div>
              <div>
                <label htmlFor="">Type</label>
                <Input />
              </div>
              <div>
                <label htmlFor="">Expiration Date</label>
                <Input />
              </div>
            </div>

           
            <Button className={styles.saveBtn} htmlType="submit">Add Driver</Button>
          </form>
        </div>
      </Modal>


        {/* Driver Info Modal */}
      <Modal
        onCancel={() => setIsDriverInfoOpen(false)}
        title={<h2 className={styles.addDriverTitle}> Driver Info</h2>}
        visible={isDriverInfoOpen}
        width={800}
        footer={null}
       
      >
        <div className={styles.addVehicleModal}>
          <form className={styles.form}>
            <h3 >Driver info</h3>
            <div className={styles.mainInfo}>
              <div>
                <label htmlFor="">First Name</label>
                <Input value={currentDriver?.first_name}/>
              </div>
              <div>
                <label htmlFor="">Last Name</label>
                <Input value={currentDriver?.last_name}/>
              </div>
              <div>
                <label htmlFor="">Date of Birth</label>
                <Input type="date" value={currentDriver?.date_of_birth}/>
              </div>
              <div>
                <label htmlFor="">Email</label>
                <Input type="email" value={currentDriver?.email}/>
              </div>
              <div>
                <label htmlFor="">SSN</label>
                <Input value={currentDriver?.ssn}/>
              </div>
              <div>
                <label htmlFor="">Address Line</label>
                <Input value={currentDriver?.address}/>
              </div>
              <div>
                <label htmlFor="">City</label>
                <Input value={currentDriver?.city}/>
              </div>
              <div>
                <label htmlFor="">State</label>
                <Input value={currentDriver?.state}/>
              </div>
              <div>
                <label htmlFor="">ZIP</label>
                <Input value={currentDriver?.zip_code}/>
              </div>
              <div>
                <label htmlFor="">Phone</label>
                <Input type="phone" value={currentDriver?.phone_number}/>
              </div>
              <div>
                <label htmlFor="">Emergency Phone</label>
                <Input type="phone" value={currentDriver?.emergency_phone}/>
              </div>
              <div>
                <label htmlFor="">Second Driver (team)</label>
                <Input className={styles.checkbox} type="checkbox"/>
              </div>
            </div>
            

           

            <h3>Driver  License</h3>
            <div className={styles.mainInfo}>
              <div>
                <label htmlFor="">License number</label>
                <Input value="3123213123"/>
              </div>
              <div>
                <label htmlFor="">License state</label>
                <Input value="Illinois"/>
              </div>
              <div>
                <label htmlFor="">Type</label>
                <Input value="E"/>
              </div>
              <div>
                <label htmlFor="">Expiration Date</label>
                <Input type="date" value="11/12/24"/>
              </div>
            </div>

           
            <Button className={styles.saveBtn}>Save</Button>
          </form>
        </div>
      </Modal>
    </div>
  );
};
